// Хук для логирования добавления в календарь
// Используем обычный fetch вместо графа, чтобы не попадало в errorExchange и не было пушей
import { getGraphqlEndpoint } from '@shared/api/api-url';

export const useAddToCalendarLog = () => {
  const addToCalendarLog = async (variables: { hash: string }) => {
    try {
      const response = await fetch(getGraphqlEndpoint(true), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken') || ''}`,
        },
        body: JSON.stringify({
          query: 'mutation addToCalendarLog($hash: String!) { addToCalendarLog(hash: $hash) }',
          variables,
        }),
      });

      if (!response.ok) {
        throw new Error('Network error');
      }
    } catch (error) {
      // Игнорируем ошибки
      return;
    }
  };

  return { addToCalendarLog };
};
